(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-jag-referral-form]').forEach(function(form) {
    var step1 = form.querySelector('[data-jag-referral-step="1"]');
    var step2 = form.querySelector('[data-jag-referral-step="2"]');
    var nextBtn = step1.querySelector('.jag-referral-form__next');
    var emailInput = step1.querySelector('input[type="email"]');
    var hiddenEmail = form.closest('form').querySelector('[data-jag-referral-email]');
    var hiddenNote = form.closest('form').querySelector('[data-jag-referral-note]');
    var outerForm = form.closest('form');

    // Belt-and-braces email validation: backs up the HTML pattern attribute via
    // setCustomValidity so checkValidity() / reportValidity() definitively fail
    // on inputs like "T@T" that pass type=email's native check.
    var jagReferralEmailRe = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    form.addEventListener('input', function(event) {
      if (!event.target.matches('input[type="email"]')) return;
      var value = event.target.value;
      if (value && !jagReferralEmailRe.test(value)) {
        event.target.setCustomValidity('Please enter a valid email address (e.g. name@example.com).');
      } else {
        event.target.setCustomValidity('');
      }
    });

    nextBtn.addEventListener('click', function() {
      if (!emailInput.reportValidity()) return;

      hiddenEmail.value = emailInput.value;
      step1.hidden = true;
      step2.hidden = false;

      var friendInput = step2.querySelector('input[type="email"]');
      if (friendInput) friendInput.focus();
    });

    outerForm.addEventListener('submit', function(event) {
      var friendInput = step2.querySelector('input[type="email"]');
      // Re-validate the friend's email at submit time — preempts any case where
      // the input event listener didn't fire (autofill, programmatic value set).
      if (friendInput && !friendInput.checkValidity()) {
        event.preventDefault();
        friendInput.reportValidity();
        return;
      }
      if (friendInput) {
        hiddenNote.value = 'Referred friend: ' + friendInput.value;
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
